"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationType = void 0;
var OperationType;
(function (OperationType) {
    OperationType["Payment"] = "PAYMENT";
    OperationType["Withdrawal"] = "WITHDRAWAL";
    OperationType["BlockchainTransaction"] = "BLOCKCHAIN_TRANSACTION";
    OperationType["Exchange"] = "EXCHANGE";
    OperationType["Failed"] = "FAILED";
    OperationType["Deposit"] = "DEPOSIT";
    OperationType["Mint"] = "MINT";
    OperationType["Revoke"] = "REVOKE";
})(OperationType = exports.OperationType || (exports.OperationType = {}));
//# sourceMappingURL=operation-type.js.map